module.exports = __webpack_public_path__ + "img/ivy_logo.309e26d6.png";